import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import Routers from "./Router";
import useGenFetcher from "./data/useFetcher";
import { SetAuthToken, SetDefaultHeaders, TOKEN } from "./data/Config";
// import { QueryClient, QueryClientProvider } from "react-query";

SetDefaultHeaders();

if (localStorage.getItem(TOKEN)) {
	SetAuthToken(localStorage.getItem(TOKEN));
}

function App() {
	let { loadUser } = useGenFetcher();

	useEffect(() => {
		loadUser();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="App">
			{/* <QueryClientProvider client={queryClient}> */}
			<Router>
				<Routers />
			</Router>
			{/* </QueryClientProvider> */}
		</div>
	);
}

export default App;
